export default {"src":"/_next/static/image/public/images/flags/flag_599.36425904cfc04bb92d0590175fad21d6.svg","height":16,"width":24};